import { clamp } from "utils/math/clamp";
import { NormalizeWheelDelta } from "./types";

export const normalizeWheelDelta: NormalizeWheelDelta = ({
  e,
  pixelMultiplier,
  lineMultiplier,
  maxDelta,
}): number => {
  let delta = e.deltaY;

  if (e.deltaMode === 0) delta *= pixelMultiplier;
  else if (e.deltaMode === 1) delta *= lineMultiplier;

  return clamp({ value: delta, min: -maxDelta, max: maxDelta });
};
